import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Smiley-plus glyph used as the "add reaction" affordance in two places: the React entry in the
 * comment row's actions toolbar, and the trailing "+" button inside the reactions chip row. Both
 * call sites used to declare their own stack of `<i class="pi pi-face-smile">` + `<i class="pi
 * pi-plus">` with subtly different offsets — extracting a single component keeps the icon
 * pixel-identical wherever it appears so the affordance reads as the same control.
 *
 * The "+" rides on top of the surface behind the smiley (no opaque background mask) so it
 * doesn't leave a halo in either light or dark mode. `currentColor` lets the glyph follow the
 * parent button's text colour automatically.
 */
@Component({
  selector: 'tf-react-icon',
  standalone: true,
  template: `
    <span class="tf-react-icon" aria-hidden="true">
      <i class="pi pi-face-smile tf-react-icon__face"></i>
      <i class="pi pi-plus tf-react-icon__plus"></i>
    </span>
  `,
  styles: [
    `
    .tf-react-icon {
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
      // Reserve breathing room for the absolutely-positioned "+" so it doesn't get clipped by
      // the parent button.
      padding-right: 4px;
      padding-top: 2px;
    }
    .tf-react-icon__face {
      font-size: 14px;
    }
    .tf-react-icon__plus {
      position: absolute;
      top: -1px;
      right: -1px;
      font-size: 8px !important;
      font-weight: 700;
      line-height: 1;
    }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReactIconComponent {}
